var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobileMenuVisible)?_c('rc-btn',_vm._b({staticClass:"rc-skip-nav-trigger",on:{"click":_vm.handleClick}},'rc-btn',_vm.$attrs,false),[_vm._v(_vm._s(_vm.$t("nav.skip_nav")))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }